import React from "react";
import arrowIcon from "./arrow.svg";
const PackageCard = ({
  name,
  features,
  image,
  selected,
  onSelect,
  setInitialOpacity,
  initialOpacity,
  setSelectedServices,
  setPrice,
  price,
}) => {
  const handleClick = () => {
    setInitialOpacity(false);
    setPrice(price);
    onSelect(name);
    setSelectedServices(features);
  };
  return (
    <div
      className={`flex flex-col border-1 text-center rounded-[24px] h-[420px] cursor-pointer text-black transform transition duration-300 hover:scale-105 border ${
        selected
          ? "border-2 border-[#3CB371]"
          : `hover:shadow-sm ${initialOpacity ? "opacity-100" : "opacity-70"}`
      }`}
      onClick={handleClick}
    >
      <img
        src={image}
        alt={`${name} logo`}
        className="w-full rounded-t-[23px] object-cover"
      />
      <ul className="mt-2 space-y-2 px-6 py-6 text-start flex-grow">
        {features?.map((feature, index) => (
          <li
            key={index}
            className="flex items-center lg:leading-loose justify-start gap-3 font-normal text-sm text-[#4D4D4D]"
          >
            <img src={arrowIcon} alt="arrow" />
            {feature}
          </li>
        ))}
      </ul>
      {selected && (
        <div className="bg-[#3CB371] text-white text-center py-2 rounded-b-[22px] font-medium text-sm">
          Selected
        </div>
      )}
    </div>
  );
};

export default PackageCard;
